import icon from 'vue-svgicon';

icon.register({
    'regular/alert-triangle': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 18.75a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375h0" stroke-linejoin="round" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5"/><path pid="1" stroke-miterlimit="10" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M12 15.75v-7.5"/><path pid="2" d="M13.621 1.76a1.806 1.806 0 0 0-3.242 0L.906 21.058a1.521 1.521 0 0 0 1.366 2.192h19.456a1.521 1.521 0 0 0 1.366-2.192z" stroke-linejoin="round" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5"/>`,
    },
});
